








import { Component, Vue } from "vue-property-decorator";
import lax from "lax.js";

@Component
export default class Circles extends Vue {
    mounted() {
        lax.init();

        lax.addDriver("scrollY", function() {
            return window.scrollY;
        });

        lax.addElements(".selector-c", {
            scrollY: {
                translateY: [
                    [0, "pageHeight"],
                    [1, "-elHeight"]
                ]
            }
        });
    }
}
